import Banner from '@/components/banner'
import { createFileRoute, Link } from '@tanstack/react-router'

export const Route = createFileRoute('/legal')({
  component: RouteComponent,
})

const legalDocs = [
  { name: 'Critical Information Summaries', url: '/cis' },
  {
    name: 'Standard Form of Agreement',
    url: '/pdf/standard-form-of-agreement.pdf',
    external: true,
  },
  {
    name: 'nbn™ Service Description',
    url: '/pdf/nbn-service-description.pdf',
    external: true,
  },
  {
    name: 'VoIP Service Description',
    url: '/pdf/voip-service-description.pdf',
    external: true,
  },
  {
    name: 'Mobile Service Description',
    url: '/pdf/mobile-service-description.pdf',
    external: true,
  },
  {
    name: 'nbn™ and VoIP Acceptable Use Policy',
    url: '/pdf/acceptable-use-policy-nbn-voip.pdf',
    external: true,
  },
  {
    name: 'Mobile Acceptable Use Policy',
    url: '/pdf/acceptable-use-policy-mobile.pdf',
    external: true,
  },
  {
    name: 'Pricing Schedule',
    url: '/pdf/pricing-schedule.pdf',
    external: true,
  },
  {
    name: 'Identity Fraud Policy',
    url: '/pdf/identity-fraud-policy.pdf',
    external: true,
  },
  {
    name: 'Hardware Warranty Policy',
    url: '/pdf/hardware-warranty-policy.pdf',
    external: true,
  },
  {
    name: 'Financial Hardship Policy',
    url: '/pdf/financial-hardship-policy.pdf',
    external: true,
  },
  {
    name: 'Privacy Policy',
    url: '/privacy-policy',
    external: true,
  },
  {
    name: 'Appointment of Authorised Representative',
    url: '/pdf/appointment-of-authorised-representative.pdf',
    external: true,
  },
  {
    name: 'Customer Service Guarantee Waiver',
    url: '/pdf/customer-service-guarantee-waiver.pdf',
    external: true,
  },
  {
    name: 'What You Need to Know',
    url: '/pdf/what-you-need-to-know.pdf',
    external: true,
  },
  {
    name: 'International Call Rates',
    url: '/pdf/international-call-rates.pdf',
    external: true,
  },
  {
    name: 'High Risk International Destinations',
    url: '/pdf/high-risk-international-destinations.pdf',
    external: true,
  },
  {
    name: `${WHOLESALERNAME} Consumer Awareness`,
    url: '/pdf/Consumer-Awareness-Scams.pdf',
    external: true,
  },
]

function RouteComponent() {
  return (
    <>
      <Banner backgroundUrl="/img/banner.jpg" containerStyle="h-[320px]" />

      <div className="breakpoint-container px-0 md:px-4 -mt-[210px] z-10 mb-20">
        <h1 className="text-6xl font-bold mb-15">Legal</h1>

        <div className="card">
          <p className=" text-2xl mb-5">
            Below are the relevant legal documents associated with the{' '}
            {WHOLESALERNAME} service offering.
          </p>
          <ul className="list-none columns-1 md:columns-2 space-y-2">
            {legalDocs.map((doc, i) => (
              <li key={i} className="break-inside-avoid ml-2 text-base">
                <Link
                  to={doc.url}
                  {...(doc.external && {
                    target: '_blank',
                    rel: 'noopener noreferrer',
                  })}
                >
                  {doc.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  )
}
